module.exports = __webpack_public_path__ + "static/img/mbk-pickup-delivery.f22330d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/mbk-pickup-delivery.jpg
// module id = oCVG
// module chunks = 0